import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isGeneralPage } from '@app/services/entities';
import { untypedIsEnabled } from '@ip-only/client-features';
import { Breakpoints, IpoMatchMediaService } from '@ip-only/front-end-library';
import { TranslationPickerComponent } from '@src/app/shared/components/translation-picker/translation-picker.component';
import { Observable } from 'rxjs';
import { Flow, ProgressService } from '../../services/progress.service';
import { SelfserviceThemeService } from '../../services/theme.service';
import {
  ProgressEntity,
  servicesProgressEntities,
} from '../../types/services-progress-entities';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';

@Component({
  selector: 'app-navbar',
  imports: [CommonModule, TranslationPickerComponent, ProgressBarComponent],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [],
})
export class NavbarComponent implements OnInit {
  public flow$: Observable<Flow>;
  public activeStep$: Observable<ProgressEntity>;
  public enabledTranslations: boolean;
  public logoUrl: string;
  public servicesProgressEntities = servicesProgressEntities;
  public breakpoints$: Observable<Breakpoints>;
  private accessId: string;
  public isOnGeneralPage = false;

  constructor(
    private themeService: SelfserviceThemeService,
    private progressService: ProgressService,
    private matchMediaService: IpoMatchMediaService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.breakpoints$ = this.matchMediaService.getBreakpoints$();
    this.enabledTranslations = untypedIsEnabled('translations');
    this.flow$ = this.progressService.getActiveFlow$();
    this.activeStep$ = this.progressService.getProgressStep$();

    this.logoUrl = this.themeService.theme.logoUrl;
    this.accessId = this.activatedRoute.snapshot.params['accessId'];
    this.isOnGeneralPage = isGeneralPage(this.accessId);
  }
}
